import { apiClient } from '../config';

// Fetch services from /items/services
export const fetchServices = async () => {
  try {
    console.log(`Fetching services from /items/services`);
    const response = await apiClient.get('/items/services');
    console.log('Services response:', response.data);
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching services:', error);
    console.error('Error details:', error.response?.data || error.message);
    throw error;
  }
};

